import { render } from "./Background.vue?vue&type=template&id=0679cc68&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=0679cc68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0679cc68"]])

export default __exports__